import imageGalleryModal from './image-gallery-modal';
import providerProfileShare from './provider-profile-share';

/**
 * Scope for the public provider page: profile sharing plus the full-page photo gallery.
 */
export default function providerPage(config = {}) {
    return {
        ...providerProfileShare(config),
        ...imageGalleryModal(),

        closeAllOverlays() {
            this.closeAllModals();
            this.closeGalleryModal();
        },
    };
}
